const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getFieldDefinitions(programId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.appliesTo) params.append('appliesTo', filters.appliesTo);
  if (filters.required !== undefined) params.append('required', filters.required);
  
  const queryString = params.toString();
  const url = `${API_BASE}/programs/${programId}/field-definitions${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch field definitions');
  }
  
  const data = await response.json();
  return data.fieldDefinitions;
}

export async function getFieldDefinition(programId, fieldId) {
  const response = await fetch(`${API_BASE}/programs/${programId}/field-definitions/${fieldId}`, {
    credentials: 'include'
  });
  
  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Field definition not found');
    }
    throw new Error('Failed to fetch field definition');
  }
  
  const data = await response.json();
  return data.fieldDefinition;
}

export async function createFieldDefinition(orgId, programId, data) {
  const response = await fetch(`${API_BASE}/programs/${programId}/field-definitions`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to create field definitions');
    }
    throw new Error('Failed to create field definition');
  }
  
  const result = await response.json();
  return result.fieldDefinition;
}

export async function updateFieldDefinition(orgId, programId, fieldId, updates) {
  const response = await fetch(`${API_BASE}/programs/${programId}/field-definitions/${fieldId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    if (response.status === 403) {
      throw new Error('You do not have permission to update field definitions');
    }
    if (response.status === 404) {
      throw new Error('Field definition not found');
    }
    throw new Error('Failed to update field definition');
  }
  
  const result = await response.json();
  return result.fieldDefinition;
}

export async function validateFields(programId, customAttributes, appliesTo) {
  const response = await fetch(`${API_BASE}/programs/${programId}/validate-fields`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ customAttributes, appliesTo })
  });
  
  if (!response.ok) {
    throw new Error('Failed to validate fields');
  }
  
  return response.json();
}
